import { useMemo } from 'react';

import { IOnePageStyles, ONE_PAGE_DISPLAY_MODE } from 'layouts/OnePagePreviewLayout';
import { ONE_PAGE_STYLE_BUTTONS } from 'layouts/OnePagePreviewLayout/constants/onePageStyleButtonsData';
import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getOnePageDisplayMode } from 'store/useBusinessToolStore/selectors';

import { useOnePageStyleAvailability } from './useOnePageStyleAvailability';

export interface IOnePageStyleButtons {
  style: IOnePageStyles;
  bgImage: string;
  isAccessed: boolean;
}

export const useGetOnePageStyleButtons = (): { data: IOnePageStyleButtons[] } => {
  const displayMode = useBusinessToolSessionStore(getOnePageDisplayMode);
  const { getIsOnePageStyleAvailable } = useOnePageStyleAvailability();

  const isExampleMode = displayMode === ONE_PAGE_DISPLAY_MODE.EXAMPLE;

  const data = useMemo(
    () =>
      ONE_PAGE_STYLE_BUTTONS.map((item) => ({
        ...item,
        isAccessed: !isExampleMode ? getIsOnePageStyleAvailable(item.style) : true,
      })),
    [isExampleMode],
  );

  return { data };
};
